import { render, staticRenderFns } from "./swipe.vue?vue&type=template&id=72b4c9c7&scoped=true&"
import script from "./swipe.vue?vue&type=script&lang=js&"
export * from "./swipe.vue?vue&type=script&lang=js&"
import style0 from "./swipe.vue?vue&type=style&index=0&id=72b4c9c7&scoped=true&lang=scss&"
import style1 from "./swipe.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4c9c7",
  null
  
)

export default component.exports